import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import RoundtripListHeader from './RoundtripListHeader';
import RoundtripListItem from './RoundtripListItem';
import Loader from '../../Dashboard/UI/Loader';
import UserNotice from '../../UserNotice/UserNotice';
import welcomeNoResults from '../../../assets/welcome/noResults.svg';
import { filterTruckTypes } from '../../../helpers/ListFiltering';
import { getFilterFindRoundtrip } from '../../../store/actions/app/roundtrip';
import ReviewModal from '../../Modals/ReviewModal/ReviewModal';
import AddReview from '../../Modals/ReviewModal/AddReview';

const RoundtripListWrapper = React.memo((props) => {
  const { USER } = props;
  const [roundtrips, setRoundtrips] = useState([]);
  const [hasSetAllRoundtrips, setHasSetAllRoundtrips] = useState(false);
  const [isExpired, setIsExpired] = useState(false);
  const [reviewModal, setReviewModal] = useState(null);
  const [addReviewModal, setAddReviewModal] = useState(null);
  const [loginGateway, setLoginGateway] = useState(false);

  const USER_PLAN = useSelector(
    (state) => state.dashboard.company?.data?.activeSubscription
  );
  const SUBSCRIPTION_NAME = useSelector(
    (state) => state.dashboard.company?.data?.subscriptionPlan?.subscriptionName
  );


  useEffect(() => {
    if (!USER && props.id) setLoginGateway(true);
  }, [USER]);

  const dispatch = useDispatch();

  // Spotload list filtering
  const { truckType, country } = props.filters;
  const { setAllRoundtrips, filters } = props;
  useEffect(() => {
    if (filters) {
      // Did cancel is used for canceling a request when the user requests another payload while the previous one is still loading
      let didCancel = false;
      const TruckTypes = filterTruckTypes(truckType);
      const CountryTypes = filterTruckTypes(country);
      dispatch(
        getFilterFindRoundtrip({
          truckType: TruckTypes,
          country: CountryTypes,
        })
      )
        .then((res) => {
          if (!didCancel) {
            const { roundtrips } = res.data;
            setRoundtrips(roundtrips);
            if (!hasSetAllRoundtrips) {
              setAllRoundtrips(roundtrips);
              setHasSetAllRoundtrips(true);
            }
          }
        })
        .catch((err) => console.log(err));
      return () => (didCancel = true);
    }
  }, [filters, truckType, country]);

  // Set subscription barrier
  
  useEffect(() => {
    if (
      (typeof SUBSCRIPTION_NAME !== 'undefined' &&
        SUBSCRIPTION_NAME === 'Free trial') ||
      (typeof USER_PLAN !== 'undefined' && !USER_PLAN)
    )
      setIsExpired(true);
  }, [USER_PLAN, SUBSCRIPTION_NAME]);

  // Add Sheet ID to localstorage to display viewed spotloads
  useEffect(() => {
    if (props.sheetID && USER && !isExpired) {
      const viewedRoundtrips = localStorage.hasOwnProperty('viewedFindRoundtrips')
        ? JSON.parse(localStorage.getItem('viewedFindRoundtrips'))
        : [];
      if (!viewedRoundtrips.includes(props.sheetID)) {
        viewedRoundtrips.push(props.sheetID);
        localStorage.setItem(
          'viewedFindRoundtrips',
          JSON.stringify(viewedRoundtrips)
        );
      }
    }
  }, [props.sheetID, USER, isExpired]);


  return (
    <RoundtripListHeader USER={USER}>
      {roundtrips?.length > 0
        ? roundtrips?.map((roundtrip) => {
          return (
            <RoundtripListItem
              USER={USER}
              isExpired={loginGateway}
              key={roundtrip._id}
              roundtrip={roundtrip}
              sheetID={props.sheetID === roundtrip._id ? props.sheetID : null}
              setSheetID={props.setSheetID}
              setReviewModal={setReviewModal}
              viewed={
                localStorage.hasOwnProperty('viewedFindRoundtrips') &&
                localStorage
                  .getItem('viewedFindRoundtrips')
                  .includes(roundtrip._id)
              }
            />
          );
        })
        : roundtrips && <Loader />}
      {!roundtrips && (
        <UserNotice
          image={welcomeNoResults}
          title="Unfortunately no offers were found. Try again with different filters or clear all filters with the button below."
          buttons={[
            {
              name: 'Clear filters',
              isButton: true,
              onClick: props.clearFilters,
            },
          ]}
        />
      )}
      {reviewModal && (
        <ReviewModal
          showHeader
          fetchReviews
          id={reviewModal}
          onClose={() => setReviewModal(null)}
          onClick={() => {
            setAddReviewModal(reviewModal);
            setReviewModal(null);
          }}
        />
      )}
      {!reviewModal && addReviewModal && (
        <AddReview
          name={reviewModal?.company?.companyName}
          id={addReviewModal}
          onClose={() => setAddReviewModal(false)}
        />
      )}
    </RoundtripListHeader>
  );
});

export default RoundtripListWrapper;
